import React from 'react';
import { Layers } from 'lucide-react';
import type { RepoStackAnalysis } from '../types';
import { Breadcrumbs } from '../../common/Breadcrumbs';

interface MapHeaderStripProps {
  data: RepoStackAnalysis;
  jobId: string;
}

export const MapHeaderStrip: React.FC<MapHeaderStripProps> = ({ data, jobId }) => {
  return (
    <div className="absolute left-56 right-0 top-0 z-10 h-14 px-6 flex items-center justify-between border-b border-slate-200 dark:border-slate-700/50 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm">
      <div className="min-w-0 [&_nav]:!mb-0">
        <Breadcrumbs
          items={[
            { label: data.repository.name, path: `/jobs/${jobId}/results` },
            { label: 'Visualize' },
          ]}
        />
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <span
          className="inline-flex items-center gap-1.5 text-[11px] font-medium px-2 py-0.5 rounded-md bg-slate-100 dark:bg-slate-800/60 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700/60"
          title="Findings reflect the entire repository"
        >
          <Layers className="w-3 h-3" />
          Aggregate view
        </span>
        <span className="hidden lg:inline text-[11px] text-slate-400 dark:text-slate-500">
          Per-project breakdown coming soon
        </span>
      </div>
    </div>
  );
};
